import type { ListProps } from '@mui/material';
import MuiList from '@mui/material/List';
import { forwardRef } from 'react';

const List = forwardRef<HTMLUListElement, ListProps>((props, ref) => {
  return <MuiList ref={ref} {...props} />;
});
export default List;
